import { render, staticRenderFns } from "./zvc-view.vue?vue&type=template&id=dd454ec0&scoped=true"
import script from "./zvc-view.vue?vue&type=script&lang=js"
export * from "./zvc-view.vue?vue&type=script&lang=js"
import style0 from "./zvc-view.vue?vue&type=style&index=0&id=dd454ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd454ec0",
  null
  
)

export default component.exports